<ng-container *ngIf="product$ | async as product">
  <ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: product }">
    <span class="brand">{{ product?.brand?.name }}</span>
    <h1
      class="name"
      [class.is-discontinued]="isDiscontinued && isDiscountinuedEnabled"
      [innerHTML]="product?.name"
    ></h1>
    <span class="text discontinued" *ngIf="isDiscontinued && isDiscountinuedEnabled">{{
      'product.discontinued' | cxTranslate
    }}</span>

    <div class="product-summary">
      <span class="attr-name">{{ 'product.productSummary.code' | cxTranslate }}</span>
      <span class="attr-value"> {{ product?.code }}</span>
      <span class="attr-name">{{
        businessType == 'fish'
          ? ('product.productSummary.eanFish' | cxTranslate)
          : janCodeEnabled
          ? ('product.productSummary.jan' | cxTranslate)
          : ('product.productSummary.ean' | cxTranslate)
      }}</span>
      <ng-container>
        <span class="attr-value" *ngIf="product?.jan || product?.ean">
          {{ janCodeEnabled ? product?.jan || product?.ean : product?.ean }}
        </span>
      </ng-container>
      <span class="attr-name">{{ 'product.productSummary.upc' | cxTranslate }}</span>
      <span class="attr-value"> {{ product?.upc }}</span>
      <ng-container *ngIf="product?.modelName">
        <span class="attr-name">{{ 'product.productSummary.modelName' | cxTranslate }}</span>
        <span class="attr-value model-name"> {{ product?.modelName }}</span>
      </ng-container>
      <ng-container *ngIf="product?.seriesName">
        <span class="attr-name">{{ 'product.productSummary.seriesName' | cxTranslate }}</span>
        <span class="attr-value"> {{ product?.seriesName }}</span>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
